import components from './validators/components/all';

import type { ComponentType } from './validators/fields/ComponentType';

const getComponentName = (type: ComponentType) => {
    return components[type]?.name ?? '';
};

export { getComponentName };
